"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var styles = {
  "FormLabel": "FormLabel__FormLabel___3d6zQ",
  "FormLabel__required-text": "FormLabel__FormLabel__required-text___3mvdm"
};
var defaultProps = {
  testId: 'cf-ui-form-label',
  requiredText: 'required',
  required: false
};

var FormLabel = function FormLabel(props) {
  var className = props.className,
      children = props.children,
      testId = props.testId,
      htmlFor = props.htmlFor,
      requiredText = props.requiredText,
      required = props.required,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "testId", "htmlFor", "requiredText", "required"]);
  var classNames = (0, _classnames["default"])(styles.FormLabel, className);
  return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
    className: classNames,
    "data-test-id": testId,
    htmlFor: htmlFor
  }, otherProps), children, required && // eslint-disable-line @typescript-eslint/no-non-null-assertion
  !!requiredText.length &&
  /*#__PURE__*/
  // eslint-disable-line @typescript-eslint/no-non-null-assertion
  _react["default"].createElement("span", {
    className: styles['FormLabel__required-text']
  }, "(", requiredText, ")"));
};

exports.FormLabel = FormLabel;
FormLabel.defaultProps = defaultProps;
var _default = FormLabel;
exports["default"] = _default;